import React, { useState, useEffect } from "react";
import axios from "axios";
import DashboardLayout from "./DashboardLayout";

function State() {

  const API = "/backend/public";

  const [name, setName] = useState("");
  const [code, setCode] = useState("");
  const [states, setStates] = useState([]);

  const fetchStates = () => {
    axios.get(`${API}/api/states`)
      .then(res => setStates(res.data));
  };

  useEffect(() => {
    fetchStates();
  }, []);

  const addState = async () => {
    await axios.post(`${API}/api/states`, { name, code });
    setName("");
    setCode("");
    fetchStates();
  };

  const deleteState = async (id) => {
    await axios.delete(`${API}/api/states/${id}`);
    fetchStates();
  };

  return (
    <DashboardLayout>

      <h3>State Management</h3>

      <div className="row mb-3">
        <div className="col-md-4">
          <input value={name} onChange={e => setName(e.target.value)} placeholder="State Name" className="form-control"/>
        </div>
        <div className="col-md-3">
          <input value={code} onChange={e => setCode(e.target.value)} placeholder="State Code" className="form-control"/>
        </div>
        <div className="col-md-2">
          <button onClick={addState} className="btn btn-primary w-100">Add</button>
        </div>
      </div>

      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Name</th>
            <th>Code</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {states.map(s => (
            <tr key={s.id}>
              <td>{s.name}</td>
              <td>{s.code}</td>
              <td>
                <button onClick={() => deleteState(s.id)} className="btn btn-danger btn-sm">Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

    </DashboardLayout>
  );
}

export default State;


